var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8C22 6.9 21.1 6 20 6H17.8C17.9 5.7 18 5.4 18 5C18 3.3 16.7 2 15 2C13.9 2 12.8 3.1 12 4.4C11.2 3.1 10.1 2 9 2C7.3 2 6 3.3 6 5C6 5.4 6.1 5.7 6.2 6H4C2.9 6 2 6.9 2 8V12H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V12H22V8ZM20 10H13V8H20V10ZM15 4C15.6 4 16 4.4 16 5C16 5.6 15.6 6 15 6H13.4C13.8 5.1 14.6 4.1 15 4ZM8 5C8 4.4 8.4 4 8.9 4C9.3 4.1 10.1 5.2 10.6 6H9C8.4 6 8 5.6 8 5ZM4 8H11V10H4V8ZM5 12H11V19H5V12ZM19 19H13V12H19V19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.41f991aff89b7cb763c2d3a2304351b0.svg";
export { ForwardRef as ReactComponent };